export default function () {
    const $wrapNav = $('.header, footer');
    $wrapNav.each(function(){
        $(this).on('click', 'a', function(e) {
            const id = $(this).attr('href');
            if (!id.includes('#')) return;
            e.preventDefault();
            console.log($(`${id}`));
            console.log($(`${id}`).offset().top);
            $('html, body').animate({
                scrollTop: $(`${id}`)[0].offsetTop
            }, 1000);
        });
    });
}